import { createContext, useContext } from 'react';
import { InventoryModule, PermissionType, RoleAuthorizationState } from 'models/permission.model';
import { RolePermission } from 'models/permission.model';
import { StoredRole } from 'utils/authorization';

export type DashboardContextType = {
  role: StoredRole | undefined;
  permissions: PermissionType[];
  setRole: (role?: StoredRole) => void;
  setPermissions: (permissions: PermissionType[]) => void;
  setRoleAuthorization: (authorization?: Partial<RoleAuthorizationState>) => void;
  clearAuthorization: () => void;
  can: (module: InventoryModule | string, actions?: RolePermission | RolePermission[]) => boolean;
  hasModuleAccess: (module: InventoryModule | string) => boolean;
  isMainAdmin: boolean;
  setIsMainAdmin: (isAdmin: boolean) => void;
};

export const RoleContext = createContext({} as DashboardContextType);

const useRoleContext = () => {
  const context = useContext(RoleContext);
  return context;
};

export default useRoleContext;
